const POST_CREATE_AGREEMENTS= "/covenants"
const GET_AGREEMENTS = "/covenants"
const PUT_AGREEMENT= "/covenants/:id"


export {
    POST_CREATE_AGREEMENTS,
    GET_AGREEMENTS,
    PUT_AGREEMENT
}